import { render, staticRenderFns } from "./smt.vue?vue&type=template&id=7c648763&scoped=true"
import script from "./smt.vue?vue&type=script&lang=js"
export * from "./smt.vue?vue&type=script&lang=js"
import style0 from "./smt.vue?vue&type=style&index=0&id=7c648763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c648763",
  null
  
)

export default component.exports